// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrelanderGamePage__root--z0BB9 {
    padding: 16px 16px 0 16px;
    width: 100%;
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
    display: flex;
    flex-direction: column;
    position: relative;
}

    @media screen and (min-width: 1024px) {.PrelanderGamePage__root--z0BB9 {
        padding: 80px 0 24px;
        min-height: 100vh
}

        .PrelanderGamePage__root--z0BB9.PrelanderGamePage__withPreview--keyad {
            padding: 24px 0;
        }
    }

    .PrelanderGamePage__root--z0BB9 > div {
        z-index: 2;
    }

.PrelanderGamePage__leftImage--XV7M8 {
    position: absolute;
    bottom: 0;
    left: 0;
    max-height: 85vh;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: bottom left;
       object-position: bottom left;
    height: auto;
    z-index: 1;
}

@media screen and (max-width: 1023px) {

.PrelanderGamePage__leftImage--XV7M8 {
        display: none
}
    }

.PrelanderGamePage__rightImage--kNphA {
    position: absolute;
    bottom: 0;
    right: 0;
    max-height: 85vh;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: bottom right;
       object-position: bottom right;
    height: auto;
    z-index: 1;
}

@media screen and (max-width: 1023px) {

.PrelanderGamePage__rightImage--kNphA {
        display: none
}
    }

.PrelanderGamePage__preview--TpYlK {
    display: grid;
    grid-template-rows: max-content 1fr 1fr max-content;
    align-items: center;
    grid-gap: 16px;
    min-height: calc(100vh - 32px);
    min-height: calc(var(--vh) * 100 - 32px);
    margin: 0 auto;
    max-width: 360px;
}

@media screen and (min-width: 1024px) {

.PrelanderGamePage__preview--TpYlK {
        min-height: calc(100vh - 48px);
        max-width: 640px
}
    }

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.PrelanderGamePage__preview--TpYlK {
        grid-gap: 24px
}
    }

.PrelanderGamePage__header--XCuUQ {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.PrelanderGamePage__logo--fTk8i {
    margin-bottom: 24px;
}

.PrelanderGamePage__logo--fTk8i img {
        width: 138px;
        height: 32px;
    }

@media screen and (min-width: 1024px) {
        .PrelanderGamePage__logo--fTk8i img {
            width: 149px;
            height: 35px;
        }
    }

.PrelanderGamePage__previewTitle--BNw15 {
    color: var(--tertiary-color);
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-transform: uppercase;
}

@media screen and (min-width: 1024px) {

.PrelanderGamePage__previewTitle--BNw15 {
        font-size: 22px;
        line-height: 28px
}
    }

.PrelanderGamePage__previewMainBlock--Anjh6 {
    margin: 0 auto;
    max-width: 360px;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.PrelanderGamePage__previewMainBlock--Anjh6 {
        max-width: 480px;
        padding: 16px;
        border: 1px solid var(--dark-tertiary-new-color);
        border-radius: 6px
}
    }

.PrelanderGamePage__previewMainBlockStep--d1NFf {
    font-size: 12px;
    line-height: 20px;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--tertiary-color);
}

.PrelanderGamePage__previewMainBlockImage--W2j6n {
    width: 100%;
    height: calc(100% - 40px);
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.PrelanderGamePage__previewMainBlockImage--W2j6n {
        height: calc(100% - 104px)
}
    }

.PrelanderGamePage__previewMainBlockTitle--K2Whg {
    font-size: 16px;
    line-height: 1.25;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    color: var(--tertiary-color);
}

.PrelanderGamePage__mainButton--AEwB8 {
    border-radius: 40px;
    padding: 16px;
    max-width: 306px;
    width: 100%;
    display: block;
    margin: 0 auto;
    margin-bottom: 16px;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.PrelanderGamePage__mainButton--AEwB8 {
        margin-bottom: 24px
}
    }

.PrelanderGamePage__copyrightText--KDbWp {
    color:#94A5CD;
    text-align: center;
    font-size: 7px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
}

@media screen and (min-width: 1024px) {

.PrelanderGamePage__copyrightText--KDbWp {
        font-size: 8px;
        letter-spacing: 0.08px
}
    }

.PrelanderGamePage__backgroundPrimaryDesktop--ZApe3 {
    position: absolute;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: bottom center;
       object-position: bottom center;
    top: 0;
    left: 0;
    mix-blend-mode: hard-light;
}

@media screen and (max-width: 1023px) {

.PrelanderGamePage__backgroundPrimaryDesktop--ZApe3 {
        display: none
}
    }

.PrelanderGamePage__backgroundSecondaryDesktop--lZoYi {
    position: absolute;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: bottom center;
       object-position: bottom center;
    top: 0;
    left: 0;
    mix-blend-mode: hard-light;
}

@media screen and (max-width: 1023px) {

.PrelanderGamePage__backgroundSecondaryDesktop--lZoYi {
        display: none
}
    }

.PrelanderGamePage__backgroundMobile--HdOXL {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: top center;
       object-position: top center;
}

@media screen and (min-width: 1024px) {

.PrelanderGamePage__backgroundMobile--HdOXL {
        display: none
}
    }
`, "",{"version":3,"sources":["webpack://./src/pages/PrelanderGamePage/PrelanderGamePage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AActB;;IAZI,uCATJ;QAUQ,oBAAoB;QACpB;AAUR;;QARQ;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,UAAU;IACd;;AAGJ;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,sBAAmB;OAAnB,mBAAmB;IACnB,+BAA4B;OAA5B,4BAA4B;IAC5B,YAAY;IACZ,UAAU;AAKd;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,sBAAmB;OAAnB,mBAAmB;IACnB,gCAA6B;OAA7B,6BAA6B;IAC7B,YAAY;IACZ,UAAU;AAKd;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mDAAmD;IACnD,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AAUpB;;AARI;;AAVJ;QAWQ,8BAA8B;QAC9B;AAMR;IALI;;AAEA;;AAfJ;QAgBQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AAavB;;AAXI;QACI,YAAY;QACZ,YAAY;IAChB;;AAEA;QACI;YACI,YAAY;YACZ,YAAY;QAChB;IACJ;;AAGJ;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAM7B;;AAJI;;AARJ;QASQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAQlC;;AANI;;AAVJ;QAWQ,gBAAgB;QAChB,aAAa;QACb,gDAAgD;QAChD;AAER;IADI;;AAGJ;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;AAK/B;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,cAAc;IACd,mBAAmB;AAKvB;;AAHI;;AATJ;QAUQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAM7B;;AAJI;;AATJ;QAUQ,cAAc;QACd;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,iCAA8B;OAA9B,8BAA8B;IAC9B,MAAM;IACN,OAAO;IACP,0BAA0B;AAK9B;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,iCAA8B;OAA9B,8BAA8B;IAC9B,MAAM;IACN,OAAO;IACP,0BAA0B;AAK9B;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,8BAA2B;OAA3B,2BAA2B;AAK/B;;AAHI;;AATJ;QAUQ;AAER;IADI","sourcesContent":[".root {\n    padding: 16px 16px 0 16px;\n    width: 100%;\n    min-height: 100vh;\n    min-height: calc(var(--vh) * 100);\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    @media (--large) {\n        padding: 80px 0 24px;\n        min-height: 100vh;\n\n        &.withPreview {\n            padding: 24px 0;\n        }\n    }\n\n    > div {\n        z-index: 2;\n    }\n}\n\n.leftImage {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    max-height: 85vh;\n    object-fit: contain;\n    object-position: bottom left;\n    height: auto;\n    z-index: 1;\n\n    @media (--mobile) {\n        display: none;\n    }\n}\n\n.rightImage {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    max-height: 85vh;\n    object-fit: contain;\n    object-position: bottom right;\n    height: auto;\n    z-index: 1;\n\n    @media (--mobile) {\n        display: none;\n    }\n}\n\n.preview {\n    display: grid;\n    grid-template-rows: max-content 1fr 1fr max-content;\n    align-items: center;\n    grid-gap: 16px;\n    min-height: calc(100vh - 32px);\n    min-height: calc(var(--vh) * 100 - 32px);\n    margin: 0 auto;\n    max-width: 360px;\n\n    @media (--large) {\n        min-height: calc(100vh - 48px);\n        max-width: 640px;\n    }\n\n    @media (--small-tablet), (--large) {\n        grid-gap: 24px;\n    }\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logo {\n    margin-bottom: 24px;\n\n    img {\n        width: 138px;\n        height: 32px;\n    }\n\n    @media (--large) {\n        img {\n            width: 149px;\n            height: 35px;\n        }\n    }\n}\n\n.previewTitle {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 24px;\n    text-transform: uppercase;\n\n    @media (--large) {\n        font-size: 22px;\n        line-height: 28px;\n    }\n}\n\n.previewMainBlock {\n    margin: 0 auto;\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    @media (--small-tablet), (--large) {\n        max-width: 480px;\n        padding: 16px;\n        border: 1px solid var(--dark-tertiary-new-color);\n        border-radius: 6px;\n    }\n}\n\n.previewMainBlockStep {\n    font-size: 12px;\n    line-height: 20px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: var(--tertiary-color);\n}\n\n.previewMainBlockImage {\n    width: 100%;\n    height: calc(100% - 40px);\n    object-fit: contain;\n    object-position: center;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n\n    @media (--small-tablet), (--large) {\n        height: calc(100% - 104px);\n    }\n}\n\n.previewMainBlockTitle {\n    font-size: 16px;\n    line-height: 1.25;\n    font-weight: 700;\n    text-transform: uppercase;\n    text-align: center;\n    color: var(--tertiary-color);\n}\n\n.mainButton {\n    border-radius: 40px;\n    padding: 16px;\n    max-width: 306px;\n    width: 100%;\n    display: block;\n    margin: 0 auto;\n    margin-bottom: 16px;\n\n    @media (--small-tablet), (--large) {\n        margin-bottom: 24px;\n    }\n}\n\n.copyrightText {\n    color:#94A5CD;\n    text-align: center;\n    font-size: 7px;\n    font-weight: 500;\n    line-height: 12px;\n    letter-spacing: 0.07px;\n    text-transform: uppercase;\n\n    @media (--large) {\n        font-size: 8px;\n        letter-spacing: 0.08px;\n    }\n}\n\n.backgroundPrimaryDesktop {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: bottom center;\n    top: 0;\n    left: 0;\n    mix-blend-mode: hard-light;\n\n    @media (--mobile) {\n        display: none;\n    }\n}\n\n.backgroundSecondaryDesktop {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: bottom center;\n    top: 0;\n    left: 0;\n    mix-blend-mode: hard-light;\n\n    @media (--mobile) {\n        display: none;\n    }\n}\n\n.backgroundMobile {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: top center;\n\n    @media (--large) {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PrelanderGamePage__root--z0BB9`,
	"withPreview": `PrelanderGamePage__withPreview--keyad`,
	"leftImage": `PrelanderGamePage__leftImage--XV7M8`,
	"rightImage": `PrelanderGamePage__rightImage--kNphA`,
	"preview": `PrelanderGamePage__preview--TpYlK`,
	"header": `PrelanderGamePage__header--XCuUQ`,
	"logo": `PrelanderGamePage__logo--fTk8i`,
	"previewTitle": `PrelanderGamePage__previewTitle--BNw15`,
	"previewMainBlock": `PrelanderGamePage__previewMainBlock--Anjh6`,
	"previewMainBlockStep": `PrelanderGamePage__previewMainBlockStep--d1NFf`,
	"previewMainBlockImage": `PrelanderGamePage__previewMainBlockImage--W2j6n`,
	"previewMainBlockTitle": `PrelanderGamePage__previewMainBlockTitle--K2Whg`,
	"mainButton": `PrelanderGamePage__mainButton--AEwB8`,
	"copyrightText": `PrelanderGamePage__copyrightText--KDbWp`,
	"backgroundPrimaryDesktop": `PrelanderGamePage__backgroundPrimaryDesktop--ZApe3`,
	"backgroundSecondaryDesktop": `PrelanderGamePage__backgroundSecondaryDesktop--lZoYi`,
	"backgroundMobile": `PrelanderGamePage__backgroundMobile--HdOXL`
};
export default ___CSS_LOADER_EXPORT___;
